/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./categorizerTable.scss');

const deps = [
  require('angular-ui-router'),
  require('data/user').name,
  require('data/collection/ledger').name,
  require('data/collection/categorizerRule').name,
  require('ui/web/table').name,
  require('ui/web/paginate').name,
  require('ui/web/nullState').name,
  require('ui/web/notifications').name,
];

module.exports = angular
  .module('bench.ui.categorizerTable', deps)

  .directive('blCategorizerTable', () => ({
    restrict: 'E',
    scope: {
      clientId: '=',
    },
    bindToController: true,
    template: require('./categorizerTable.html'),
    controller: require('./categorizerTableCtrl.js'),
    controllerAs: 'vm',
  }));
